import { RgbaColor, colord } from 'colord';

export interface Gradient {
  gradientType: 'linear-gradient' | 'radial-gradient' | null;
  gradientDirection: string | null;
  colorList: { rgba: RgbaColor | undefined; stop: number | null }[];
  distributeEvenly: boolean;
}

export function parseGradientString(input?: string): Gradient {
  if (!input)
    return {
      colorList: [],
      distributeEvenly: true,
      gradientDirection: null,
      gradientType: null,
    };

  const linearGradientRegex = /^linear-gradient\(([\d.]+deg)?(.*?)\)$/i;
  const circularGradientRegex = /^radial-gradient\(([\d.]+deg)?(.*?)\)$/i;

  if (linearGradientRegex.test(input)) {
    const [, gradientDirection, colorStops] = input.match(linearGradientRegex)!;
    const gradientType = 'linear-gradient';
    const colorList = parseColorStops(colorStops);
    const distributeEvenly = colorList.every((color) => color.stop === null);

    return {
      gradientType,
      gradientDirection: gradientDirection || null,
      colorList,
      distributeEvenly,
    };
  } else if (circularGradientRegex.test(input)) {
    const [, gradientDirection, colorStops] = input.match(
      circularGradientRegex
    )!;
    const gradientType = 'radial-gradient';
    const colorList = parseColorStops(colorStops);
    const distributeEvenly = colorList.every((color) => color.stop === null);

    return {
      gradientType,
      gradientDirection: gradientDirection || null,
      colorList,
      distributeEvenly,
    };
  } else {
    return {
      colorList: [],
      distributeEvenly: true,
      gradientDirection: null,
      gradientType: null,
    };
  }
}

function parseColorStops(
  input: string
): { rgba: RgbaColor | undefined; stop: number | null }[] {
  const colorStopRegex = /#(?:[0-9a-fA-F]{3,8})(?:[\d.]+%?)?/g;
  const colorStops = input.match(colorStopRegex);

  if (colorStops) {
    return colorStops.map((colorStop) => {
      const stopMatch = colorStop.match(/[\d.]+%/);
      const stop = stopMatch ? parseFloat(stopMatch[0]) : null;

      const fullColorMatch = colorStop.match(/#(?:[0-9a-fA-F]{3,8})/);
      const color = fullColorMatch ? fullColorMatch[0] : '';

      return {
        rgba: colord(color).toRgb(),
        stop,
      };
    });
  } else {
    return [];
  }
}
